import React, { useRef, useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export function SplitDropdown(props) {
  const { className, id, onClick, color, icon, label, menu } = props;

  const toggler = useRef(null);
  const dropdownMenu = useRef(null);

  const [showDropdown, _setShowDropdown] = useState(false);
  const toggleDropdown = () => _setShowDropdown(!showDropdown);

  const handleClick_splitDropdown = (e) => {
    if (
      e.target.id !== `splitDrop_${id}_toggler` &&
      e.target.className !== "dropdown-item"
    ) {
      _setShowDropdown(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClick_splitDropdown);
    document.addEventListener("touchstart", handleClick_splitDropdown);

    return () => {
      document.removeEventListener("mousedown", handleClick_splitDropdown);
      document.removeEventListener("touchstart", handleClick_splitDropdown);
    };
  }, []);

  return (
    <div className={`btn-group${className ? ` ${className}` : ""}`}>
      <button
        type="button"
        id={`splitDrop_${id}`}
        className={`btn btn-${color}`}
        onClick={onClick}
      >
        {icon && <FontAwesomeIcon icon={icon} className="mr-1" />}
        {label}
      </button>
      <button
        type="button"
        id={`splitDrop_${id}_toggler`}
        className={`btn btn-outline-${color} dropdown-toggle dropdown-toggle-split`}
        onClick={toggleDropdown}
        ref={toggler}
      />
      <div
        className={`dropdown-menu w-100${showDropdown ? " show" : ""}`}
        id={`splitDrop_${id}_menu`}
        ref={dropdownMenu}
      >
        {(menu || []).length &&
          menu
            .filter((i) => i.show)
            .map((i, index) => (
              <SplitDropdownItem
                key={`splitDrop_${id}_item_${index}`}
                onClick={i.onClick}
                label={i.label}
                icon={i.icon}
                iconClass={i.iconClass || null}
                toggleDropdown={toggleDropdown}
              />
            ))}
      </div>
    </div>
  );
}

export function SplitDropdownItem(props) {
  const { onClick, label, icon, iconClass, toggleDropdown } = props;

  const handleClick = (e) => {
    e.preventDefault();
    onClick();
    toggleDropdown();
  };

  return (
    <div className="dropdown-item" style={{ cursor: "pointer" }} onClick={handleClick}>
      {icon && (
        <FontAwesomeIcon
          icon={icon}
          className={`fa-fw mr-2${iconClass ? ` ${iconClass}` : " text-muted"}`}
        />
      )}
      {label}
    </div>
  );
}

export const SplitDropdownSeparator = () => <div className="dropdown-divider"></div>;
